import React from 'react'; 
import { connect } from 'react-redux'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { LoadingComponent } from '../../utils/ui'
import { DMLActions, Linker } from '../../redux';
import FileSelectPage from '../../components/dml/FileSelectPage';
import { makeURL } from '../../components/dml/helper';
import { TEAMWORK } from '../../const/C';

/**
 * Спциальный объект, проксирующие выбор файлов из DLM
 * Основная задача - загрузить необходимые данные и после из загрузки отобразить выбор файла
 */
class FileSelectProxy extends React.Component {

  state = {
    loaded: false, 			  //Флаг загрузки, необходимый данных
  }


  static getDerivedStateFromProps(props, state) {
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    this.loadDLMItems()
  }

  loadDLMItems() {
    this.setState({loaded: false})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание
      this.props.onLoadItems(),
    ])
    .then ((response) =>{
      this.setState({loaded: true, error: undefined});
    })
    .catch(e => { 
      this.setState({loaded: true, error: e});
    });
  }

  onSelected (selectedKeys, info) {
    if (info.node.props.dataRef.fileName)
      return this.props.onSelect(info);
  }

  render() {
    console.log(this);
    let { loaded } = this.state;
    if (!loaded) return <LoadingComponent />;
    return (
      <FileSelectPage onSelect={(selectedKeys, info) => this.onSelected(selectedKeys, info)} />
    )
  }
}

//Представление информации о Wiki статьях
export default connect(
  (state, props) => {
    const {vset, ldml} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      selected: ldml.file,
    })
  },
  dispatch => ({
    onSelect (info)  {
      console.log('FileSelectProxy.js onSelect (info)', info);
      const label = (info.node.props.dataRef.fileName)?info.node.props.dataRef.fileName:info.node.props.dataRef.name;
      return dispatch(Linker.SELECTED(TEAMWORK.PREDICAT_FILE, makeURL(info.node.props.dataRef), label))
    },
    onLoadItems(){
      return dispatch(DMLActions.loadItems());
    },
  })
)(FileSelectProxy)

